module.exports = __webpack_public_path__ + "img/p1.e0eccf89.png";